export default {
  endpoint: 'wss://suggest.customer.envato.com/socket',
  channel: 'autocomplete:standard'
}
